/*
 * @Author: shannyHuang
 * @Date: 2022-08-23 10:53:40
 * @LastEditors: brucexlliu
 * @LastEditTime: 2023-04-28 14:22:31
 * @FilePath: \wemeet-web-activity\src\components\EventDetailNav\index.tsx
 */
import '@tencent/tpm-meeting-active/lib/ConsolePanel/style';
import Layout from '@tencent/tpm-meeting-active/lib/Layout';
import '@tencent/tpm-meeting-active/lib/Layout/style';
import AsideBar from '@tencent/tpm-meeting-active/lib/AsideBar';
import '@tencent/tpm-meeting-active/lib/AsideBar/style';
import ErrorStoreProvider from '@utils/event-store/useEventData';
import { useRouter } from 'next/router';
import { FC, useCallback, useEffect, useState } from 'react';
import Loading from 'src/components/Loading/Loading';
import { useActivityBriefInfo } from 'src/hooks/useActivityInfo';
import Error from 'src/pages/_error.page';
import { SWRConfig } from 'swr';
import CustomFooter from 'src/components/Layout/CustomFooter';
import { NO_PROTOCOL_PATH } from 'src/components/Layout/CustomFooter/data';
import DetailCard, { DisablePage } from './DetailCard';
import PublishDialog from 'src/components/EventDetailNav/Publish';
import EventNavBar from '@component/EventNavBar';
import EventMenus from './Menu';
import logo from './img/logo.png';
import './index.scss';
import Head from 'next/head';
import useCommercialize from '@hooks/useCommercialize';
const { Body, Sider, Content } = Layout;

const EventDetailNav: FC = ({ children }) => {
  const router = useRouter();
  const { query, pathname } = router;
  const eventId = String(query.eventid);
  const { activityInfo, error: activityInfoErr } = useActivityBriefInfo({ event_id: eventId });

  const [noProtocol, setNoProtocol] = useState(false);
  const { updateVipResource } = useCommercialize();
  useEffect(() => {
    setNoProtocol(NO_PROTOCOL_PATH.includes(pathname.split(']/')[1]));
  }, [pathname]);

  const setLoading = useCallback((show: boolean, id = 'pg-loading') => {
    if (show) {
      Loading.show({ logo: 'meeting', id });
      return;
    }
    Loading?.close({ id });
  }, []);

  useEffect(() => {
    setLoading(true);
    const t1 = setTimeout(() => {
      setLoading(false);
      clearTimeout(t1);
    }, 3 * 1000);
  }, []);

  useEffect(() => {
    if (!activityInfo?.host_id) return;
    setLoading(false);
    const hostId = (activityInfo?.host_id as unknown as string) || '';
    updateVipResource?.(hostId);
  }, [activityInfo?.host_id]);

  const toIndex = () => {
    router.push('/index');
  };

  if (activityInfoErr) return <Error />;

  return (
    <div className="page-event">
      <Head>
        <title>编辑活动</title>
      </Head>
      <Layout full>
        <Body layout="horizontal">
          <ErrorStoreProvider>
            <Sider left>
              <AsideBar className="event-asideBar" userProps={{ name: '' }}>
                <img className="event-logo" src={logo} onClick={toIndex} />
                <AsideBar.Box>
                  <DetailCard />
                </AsideBar.Box>
                <AsideBar.Box scrollable>
                  <EventMenus />
                </AsideBar.Box>
              </AsideBar>
            </Sider>
            <div className="page-event-content">
              <EventNavBar />
              <Content showBackButton={false} backButtonText={null}>
                {noProtocol ? (
                  <SWRConfig value={{ provider: (cache) => cache }}>{children}</SWRConfig>
                ) : (
                  <>
                    <div className="page-event-content-box">
                      <SWRConfig value={{ provider: (cache) => cache }}>{children}</SWRConfig>
                    </div>
                    <CustomFooter />
                  </>
                )}
                <DisablePage />
                <PublishDialog />
              </Content>
            </div>
          </ErrorStoreProvider>
        </Body>
      </Layout>
      <div id="pg-loading" />
    </div>
  );
};

export default EventDetailNav;
